var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PortalWidget", { attrs: { widget: _vm.widgetTitle } }, [
    !_vm.isLoadingTransactions
      ? _c(
          "div",
          {
            staticClass: "grid_table_holder",
            attrs: { "data-testid": "transaction-history" }
          },
          [
            _c(
              "v-table",
              {
                staticClass: "table_beauty",
                attrs: {
                  data: _vm.transactionHistory,
                  "current-page": _vm.currentPage,
                  "page-size": 20,
                  "hide-sort-icons": true
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function($event) {
                    _vm.currentPage = $event
                  },
                  totalPagesChanged: function($event) {
                    _vm.totalPages = $event
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function({ displayData }) {
                        return _c(
                          "tbody",
                          {},
                          [
                            !_vm.transactionHistory.length
                              ? _c("tr", [
                                  _c("td", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "TRANSACTION_HISTORY_EMPTY",
                                        expression:
                                          "'TRANSACTION_HISTORY_EMPTY'"
                                      }
                                    ],
                                    attrs: { colspan: "100" }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(displayData, function(row, index) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    key: row.refId,
                                    class: {
                                      "bg-row-odd": index % 2 === 0,
                                      "bg-row-even": index % 2 !== 0
                                    }
                                  },
                                  [
                                    _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.formatDate(row.dtStamp)) +
                                          "\n            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(row.description) +
                                          "\n            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatCurrency(
                                              row.amount.amount
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("i", {
                                        staticClass: "credit-card-img",
                                        class: row.cardType
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n              xxxx-xxxx-xxxx-" +
                                          _vm._s(row.cC_Last_4) +
                                          "\n            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-list-function",
                                          attrs: {
                                            "data-testid":
                                              "v2-billing-transaction-export-btn",
                                            disabled: row.isExportingInvoice
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.exportCreditCardInvoice(
                                                row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          row.isExportingInvoice
                                            ? _c("Loader", {
                                                attrs: {
                                                  "custom-class": "size-sm"
                                                }
                                              })
                                            : _c("i", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName:
                                                      "v-tooltip.right.hover",
                                                    value: {
                                                      text: _vm.$t(
                                                        "ACCOUNT_BILLING_HISTORY_INVOICE_TT"
                                                      ),
                                                      transition: 0
                                                    },
                                                    expression:
                                                      "{ text:$t('ACCOUNT_BILLING_HISTORY_INVOICE_TT'), transition: 0 }",
                                                    modifiers: {
                                                      right: true,
                                                      hover: true
                                                    }
                                                  }
                                                ],
                                                staticClass: "fa fa-download",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      }
                    }
                  ],
                  null,
                  false,
                  4145650622
                )
              },
              [
                _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                  _c(
                    "tr",
                    [
                      _c("v-th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "ACCOUNT_BILLING_HISTORY_DATE",
                            expression: "'ACCOUNT_BILLING_HISTORY_DATE'"
                          }
                        ],
                        attrs: { "default-sort": "desc", "sort-key": "dtStamp" }
                      }),
                      _vm._v(" "),
                      _c("v-th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "ACCOUNT_BILLING_HISTORY_DESCRIPTION",
                            expression: "'ACCOUNT_BILLING_HISTORY_DESCRIPTION'"
                          }
                        ],
                        attrs: { "sort-key": "description" }
                      }),
                      _vm._v(" "),
                      _c("v-th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "ACCOUNT_BILLING_HISTORY_AMOUNT",
                            expression: "'ACCOUNT_BILLING_HISTORY_AMOUNT'"
                          }
                        ],
                        attrs: { "sort-key": "amount.amount" }
                      }),
                      _vm._v(" "),
                      _c("v-th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "ACCOUNT_BILLING_HISTORY_TYPE",
                            expression: "'ACCOUNT_BILLING_HISTORY_TYPE'"
                          }
                        ],
                        attrs: { "sort-key": "cardType" }
                      }),
                      _vm._v(" "),
                      _c("v-th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "ACCOUNT_BILLING_HISTORY_NUMBER",
                            expression: "'ACCOUNT_BILLING_HISTORY_NUMBER'"
                          }
                        ],
                        attrs: { "sort-key": "cC_Last_4" }
                      }),
                      _vm._v(" "),
                      _c("th", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "TRANSACTION_HISTORY_RECEIPT",
                            expression: "'TRANSACTION_HISTORY_RECEIPT'"
                          }
                        ]
                      })
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _vm.transactionHistory && _vm.transactionHistory.length
              ? _c("div", { staticClass: "pagination-min" }, [
                  _c(
                    "div",
                    { staticClass: "text-center p-7" },
                    [
                      _c("smart-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage,
                          "total-pages": _vm.totalPages,
                          "max-page-links": 7
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.currentPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.currentPage = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "text-center empty-records" },
          [
            _c("Loader"),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "LOADING",
                  expression: "'LOADING'"
                }
              ]
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }